<div class="questionarios-page">
  <app-back-button data-testid="questionarios-list-voltar" (back)="voltar()" />

  <app-page-header title="Questionários">
    <button
      actions
      type="button"
      class="btn btn-primary"
      data-testid="btn-adicionar-questionario"
      (click)="onAdicionar()"
    >
      Adicionar
    </button>
  </app-page-header>

  <app-filter-bar [fields]="filterFields" (filtersChange)="onFiltersChange($event)" />

  <section aria-labelledby="questionarios-section-title">
    <h2 id="questionarios-section-title" class="page-section-title">Questionários criados</h2>

    @if (questionariosFiltrados().length === 0) {
      <app-empty-state message="Nenhum questionário encontrado" />
    } @else {
      <app-data-table ariaLabel="Questionários criados">
        <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Status</th>
            <th scope="col">Última atualização</th>
            <th scope="col"><span class="visually-hidden">Ações</span></th>
          </tr>
        </thead>
        <tbody>
          @for (questionario of questionariosPaginados(); track questionario.id) {
            <tr>
              <td>
                <a
                  class="table-link"
                  [routerLink]="['/questionarios', questionario.id, 'editar']"
                  data-testid="questionario-link"
                >
                  {{ questionario.nome }}
                </a>
              </td>
              <td>
                <app-status-badge [status]="questionario.status" />
              </td>
              <td>{{ formatDate(questionario.ultimaAtualizacao) }}</td>
              <td class="actions-cell">
                <div
                  class="actions-menu"
                  [class.actions-menu--open]="menuAbertoId() === questionario.id"
                >
                  <button
                    type="button"
                    class="actions-menu-btn"
                    [attr.aria-expanded]="menuAbertoId() === questionario.id"
                    aria-haspopup="true"
                    [attr.aria-label]="'Ações para ' + questionario.nome"
                    data-testid="actions-menu-btn"
                    (click)="toggleMenu(questionario.id, $event)"
                  >
                    &#8942;
                  </button>
                  @if (menuAbertoId() === questionario.id) {
                    <div
                      class="actions-menu-dropdown actions-menu-dropdown--fixed"
                      role="menu"
                      [style.top.px]="menuPosition()?.top"
                      [style.right.px]="menuPosition()?.right"
                    >
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="action-editar"
                        (click)="irParaEditar(questionario.id)"
                      >
                        Editar
                      </button>
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="action-excluir"
                        (click)="abrirConfirmacaoExclusao(questionario.id, $event)"
                      >
                        Excluir
                      </button>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </app-data-table>

      <app-pagination
        [currentPage]="currentPage()"
        [pageSize]="pageSize"
        [totalItems]="questionariosFiltrados().length"
        (pageChange)="onPageChange($event)"
      />
    }
  </section>

  @if (showDeleteDialog()) {
    <app-alert-dialog
      title="Excluir Questionário"
      message="Tem certeza que deseja excluir este questionário?"
      description="Essa ação removerá permanentemente o questionário selecionado."
      cancelLabel="Cancelar"
      confirmLabel="Excluir"
      [showConfirmIcon]="false"
      (cancel)="cancelarExclusao()"
      (confirm)="confirmarExclusao()"
    />
  }
</div>
